__turbopack_context__.v({
  "stack": "CompositeCard-module__LrtSYG__stack",
});
